import React, { useCallback, useEffect, useState } from 'react'
import { Box, Button, Card, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { getFromStorage } from '../../utils/storage'
import { DOMAIN, api } from '../../utils/api'
import { handleError } from '../../utils/error'
import UserLayout from '../../layouts/UserLayout'
import { currentUserActions } from '../../redux/store'
import { useDispatch } from 'react-redux'
import { mainGreen } from '../../utils/color'

export default function EditUserSM() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const { userId } = useParams()
	const [user, setUser] = useState()
	const [roleId, setRoleId] = useState('')
	const [roles, setRoles] = useState([])

	const handleChangeSelectRole = (event) => {
		setRoleId(event.target.value)
	}

	const getUser = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/storeManager/user/${userId}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setRoleId(response.data.role._id)
				setUser(response.data)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, userId, navigate, dispatch],
	)

	useEffect(() => {
		getUser()
	}, [getUser])

	const getRoles = useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_ROLES_STORE_MANAGER,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setRoles(response.data)
			} catch (error) {
				console.log(error.response.data.message)
			}
		},
		[token],
	)

	useEffect(() => {
		getRoles()
	}, [getRoles])

	const editUser = async function () {
		try {
			const response = await axios({
				url: `${DOMAIN}/storeManager/edit-user/${userId}`,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				method: 'PUT',
				data: { roleId },
				withCredentials: true,
			})
			if (response.status === 200) {
				alert(response.data.message)
			}
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}
	return (
		<UserLayout>
			<Box sx={{ maxWidth: 992, margin: '0 auto' }}>
				<Card sx={{ margin: '20px 20px 10px 20px', padding: '10px' }}>
					<Typography sx={{ mb: 2 }}>Tên: {user?.name}</Typography>
					<Typography sx={{ mb: 2 }}>Email: {user?.email}</Typography>
					<FormControl sx={{ mt: 1, mr: 2, minWidth: 120 }} size='small'>
						<InputLabel id='role-select-small-label'>Vị trí</InputLabel>
						<Select
							required
							labelId='role-select-small-label'
							id='demo-select-small'
							label='Vị trí'
							value={roleId}
							onChange={handleChangeSelectRole}>
							{roles?.map((role, index) => {
								return (
									<MenuItem key={index} value={role._id}>
										{role.description}
									</MenuItem>
								)
							})}
						</Select>
					</FormControl>
					<Box sx={{ mt: 2 }}>
						<Button
							sx={{
								marginLeft: 'auto',
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}
							fullWidth
							size='small'
							variant='contained'
							onClick={() => {
								const confirmEdit = window.confirm('Bạn có chắc muốn cập nhật vị trí làm việc người dùng này?')
								if (confirmEdit) {
									editUser()
									navigate('/store-manager/users')
								}
							}}>
							Cập nhật
						</Button>
					</Box>
				</Card>
			</Box>
		</UserLayout>
	)
}
